import { render, staticRenderFns } from "./TextCard.vue?vue&type=template&id=d39e6ea0"
import script from "./TextCard.vue?vue&type=script&lang=ts"
export * from "./TextCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports